/**
 * What an AI reply contains that can be exported — shared by the full AI
 * Assistant chat and the Maya sidebar so "Save PDF" appears for the same
 * replies in both.
 */
const MARKDOWN_TABLE_RE = /\|[^\n]*\|\s*\n\s*\|[ :|-]+\|/;
const MERMAID_BLOCK_RE = /```mermaid/i;

/** The reply has a table or a chart the server can render to PDF. */
export const messageHasDownloadable = (content: string) =>
  MARKDOWN_TABLE_RE.test(content) || MERMAID_BLOCK_RE.test(content);
